import React, { useEffect, useState } from 'react'
import { useInput } from 'Helpers/'
import Input from 'Components/shared/Input'
import { ErrorText, SuccessText } from 'Components/shared/Typography'
import { Button } from 'Components/shared/Button'

import { Flex } from 'lese'
import { SelectIcon } from 'Components/shared/Select'

// TODO: The original one had horrible icon to value reference. need to fix that
const icons = [
  { text: 'FAQ', value: 13 },
  { text: 'Shopping', value: 1 },
  { text: 'Website', value: 2 },
  { text: 'Facebook', value: 3 },
  { text: 'Twitter', value: 4 },
  { text: 'Merchandise', value: 5 },
  { text: 'Tag', value: 6 },
  { text: 'Settings', value: 7 },
  { text: 'Diamond', value: 8 },
  { text: 'Pinterest', value: 9 },
  { text: 'YouTube', value: 10 },
  { text: 'Instagram', value: 11 },
  { text: 'News', value: 12 },
  { text: 'Calendar', value: 14 },
  { text: 'News', value: 15 },
  { text: 'Maps', value: 16 },
  { text: 'Videos', value: 17 },
  { text: 'Merchandise', value: 18 },
  { text: 'Signal', value: 19 },
  { text: 'Team', value: 20 }
]

export default ({ selectedClub, updateLinks, links }) => {
  const [errorText, setErrorText] = useState('')
  const [successText, setSuccessText] = useState('')
  const [club, setClub] = useState()
  const [icon, setIcon] = useState(13)

  const shortNameHook = useInput()
  const longNameHook = useInput()
  const urlHook = useInput()

  useEffect(async () => {
    if (!selectedClub) return

    setClub(selectedClub)
  })

  const createCustomLink = async () => {
    if (!shortNameHook.value || !longNameHook.value || !urlHook.value) {
      setErrorText('Please populate all fields')
      setSuccessText('')

      return
    }

    const data = {
      clubimpact_id: club.id,
      icon: parseInt(icon, 10),
      shortname: shortNameHook.value,
      longname: longNameHook.value,
      url: urlHook.value,
      deleted: 0
    }
    const updatedLinks = [...links, data]
    updateLinks(updatedLinks)
  }

  return (
    <Flex row separation="24px" yAlign="center">
      <SelectIcon
        onChange={e => {
          setIcon(e.newIndex)
        }}
        options={icons}
        defaultIndex={13}
        height="15vh"
        style={{ width: '125px' }}
      />
      {/* Icon */}
      <Input placeholder="Name" {...shortNameHook.bind} /> {/* Name */}
      <Input placeholder="Description" {...longNameHook.bind} /> {/* Description */}
      <Input placeholder="Link" {...urlHook.bind} /> {/* URL */}
      <Button onClick={createCustomLink}>Create</Button>
      {errorText && <ErrorText>{errorText}</ErrorText>}
      {successText && <SuccessText>{successText}</SuccessText>}
    </Flex>
  )
}
